// extracted by mini-css-extract-plugin
export var ckbtn = "shippingForm-module--ckbtn--nwUQA";
export var addressTitle = "shippingForm-module--addressTitle--KLKuC";
export var CCTitle = "shippingForm-module--CCTitle--2Ti7F";
export var shipingForm = "shippingForm-module--shipingForm--3Ceeh";
export var error = "shippingForm-module--error--P2LSN";